import { render, staticRenderFns } from "./PagePerformanceReviews.vue?vue&type=template&id=1ec16a1f&scoped=true&"
import script from "./PagePerformanceReviews.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviews.vue?vue&type=script&lang=js&"
import style0 from "./PagePerformanceReviews.vue?vue&type=style&index=0&id=1ec16a1f&scoped=true&lang=css&"
import style1 from "./PagePerformanceReviews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec16a1f",
  null
  
)

export default component.exports